import React from 'react';
import { Text } from 'components/Typography';
import { ComingSoonLabel } from 'containers/ComingSoonLabel/ComingSoonLabel';
import { SVGBasicType } from 'types/global';
import { Color } from 'utils/color';
import style from './NominalRangeCard.scss';

type Props = {
  title?: string;
  imgSrc?: string;
  size?: 'sm' | 'lg';
  hasComingSoonLabel?: boolean;
  nominalRange: [number, number];
  rawValue?: number;
  value: string | number;
  unit?: string;
};

export const NominalRangeCard: React.FC<Props> = ({ title, size = 'lg', hasComingSoonLabel = false, nominalRange, rawValue, value, unit }) => {
  const isLarge = size === 'lg';

  const possibleValues = rawValue != null ? [rawValue, ...nominalRange] : [...nominalRange];

  const totalRange: [number, number] = [Math.min(...possibleValues), Math.max(...possibleValues)];
  const totalRangeDiff = totalRange[1] - totalRange[0];
  const nominalPercentage = [(nominalRange[0] - totalRange[0]) / totalRangeDiff, (totalRange[1] - nominalRange[1]) / totalRangeDiff];
  const valuePercentage = rawValue != null ? (rawValue - totalRange[0]) / totalRangeDiff : null;

  if (!isLarge) {
    return (
      <div className={style.smallCard}>
        <div className={style.content}>
          <div className={style.textWrapper}>
            <Text variant="nlg" className={style.title}>
              {title}
            </Text>
            {hasComingSoonLabel ? (
              <ComingSoonLabel />
            ) : (
              <Text variant="h5" weight={500}>
                {value || '-'}
              </Text>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={style.card}>
      <div className={style.cardTitleContainer}>
        <Text variant="md" weight={500}>
          {title}
        </Text>
      </div>
      <div className={style.content}>
        <div className={style.nominalRangeContainer}>
          <div className={style.nominalRangeBox} style={{ left: `${100 * nominalPercentage[0]}%`, right: `${100 * nominalPercentage[1]}%` }}></div>
          {valuePercentage != null && <div className={style.valueIndicator} style={{ left: `${100 * valuePercentage}%` }}></div>}
        </div>

        <div className={style.vitalValueContainer}>
          <Text variant="h3" className={style.vitalValueText}>
            {value ?? '-'}
          </Text>
          {unit && (
            <Text variant="md" className={style.vitalValueUnit}>
              {unit}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
